import React from 'react';
import { BodyText, ButtonDropdown, ButtonText, FlexRow, TDropdownElementProps } from 'ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { faCheck, faFilter as faLightFilter } from '@fortawesome/pro-light-svg-icons';
import {
  eTaxCertificationRequestStatus,
  prettyVendorStatus,
} from '../../types/order/title/eTaxCertificationRequestStatus';
import { GreenText } from './styledComponents/GreenText';

interface IVendorTaxCertificationRequestsFilterProps {
  statuses: eTaxCertificationRequestStatus[];
  filterOptions: eTaxCertificationRequestStatus[];
  defaultStatuses: eTaxCertificationRequestStatus[];
  onFilterPayoff: (value: eTaxCertificationRequestStatus[]) => void;
}

export const VendorTaxCertificationRequestsFilter: React.FC<IVendorTaxCertificationRequestsFilterProps> = ({
  statuses,
  filterOptions,
  defaultStatuses,
  onFilterPayoff,
}) => {
  const selectedFilter: eTaxCertificationRequestStatus | null = statuses.length === 1 ? statuses[0] : null;

  const options: TDropdownElementProps[] = filterOptions.map((status: eTaxCertificationRequestStatus) => ({
    children: (
      <FlexRow>
        <GreenText>{selectedFilter === status ? <FontAwesomeIcon icon={faCheck} /> : null}</GreenText>
        <BodyText>{prettyVendorStatus[status]}</BodyText>
      </FlexRow>
    ),
    onClick: () => (selectedFilter === status ? onFilterPayoff(defaultStatuses) : onFilterPayoff([status])),
  }));

  return (
    <ButtonDropdown items={options} intent={selectedFilter ? 'secondary' : 'primary'}>
      <FlexRow>
        <FontAwesomeIcon icon={selectedFilter ? faFilter : faLightFilter} />
        <ButtonText>Filter Results</ButtonText>
      </FlexRow>
    </ButtonDropdown>
  );
};
